import {
  includesString,
  excludesString,
  equalsString,
  notEquals,
  lessThan,
  greaterThan,
  lessThanOrEqual,
  greaterThanOrEqual,
  isEmpty,
  isNotEmpty,
} from "@/lib/filters/filterFunctions";
import { FilterType } from "@/lib/filters/FilterType";
import { FilterFn } from "@tanstack/react-table";

export const mapFilterTypeToFilterFn = <TData>(
  filter: FilterType,
): FilterFn<TData> => {
  switch (filter) {
    case FilterType.IncludesString:
      return includesString;
    case FilterType.ExcludesString:
      return excludesString;
    case FilterType.EqualsString:
      return equalsString;
    case FilterType.NotEquals:
      return notEquals;
    case FilterType.LessThan:
      return lessThan;
    case FilterType.GreaterThan:
      return greaterThan;
    case FilterType.LessThanOrEqual:
      return lessThanOrEqual;
    case FilterType.GreaterThanOrEqual:
      return greaterThanOrEqual;
    case FilterType.IsEmpty:
      return isEmpty;
    case FilterType.IsNotEmpty:
      return isNotEmpty;
    default:
      throw new Error(`Unknown filter: ${filter}`);
  }
};
